import React from 'react';
import { useDataProps } from './use-data-props';
import { useAriaProps } from './use-aria-props';
/**
 * Utility hook that combines useDataProps and useAriaProps to extract both
 * accessibility and data test related props from component props
 * @param props The component props from which to extract accessibility and data attributes
 * @returns An object containing all aria-* and data-* attributes
 */
export const useAriaAndDataProps = (props) => {
    const dataProps = useDataProps(props);
    const ariaProps = useAriaProps(props);
    return React.useMemo(() => ({
        ...dataProps,
        ...ariaProps,
    }), [dataProps, ariaProps]);
};
